import { manageIncentiveReducer } from './reducers/incentiveReducer';

import { sidebarOptionsReducer } from "./reducers/sidebarReducer"
import { configTypeReducer } from "./reducers/configTypeReducer"
import {combineReducers} from 'redux'
import { ServiceRegistryReducer } from "./reducers/serviceRegistryReducer";
import { mdmReducer } from "./reducers/mdmReducer";
import { IntegrationDashboardReducer } from "./reducers/integrationDashboardReducer";
import { bannerReducer } from "./reducers/bannerReducer";
import { genericPopupReducer } from "./reducers/genericPopupReducer";
import { FileFormatReducer } from "./reducers/fileFormat";
import { DateFilterReducer } from "./reducers/dateFilterReducer";
import { validateOtpPopupReducer } from "./reducers/validateOtpPopupReducer";
import { genericFilterReducer } from "./reducers/genericFilterReducer";
import { LocationDataReducer } from "./reducers/locationDataReducer";
import { manageRoleReducer } from "./reducers/manageRoleReducer";
import { valiadteAPIReducer } from "./reducers/validateAPIReducer";
import { portalConfigReducer } from "./reducers/portalConfigReducer";
import { manageCouponReducer } from "./reducers/manageCouponsReducer";
import { schemePlaygroundReducer } from "./reducers/playGroundCouponsReducer";
import { eventReducer } from "./reducers/eventReducer";
import claimsReducer from "./reducers/claimsReducer";
import loyaltyManagementReducer from "./reducers/loyaltyManagementReducer";
import { roleReducer } from "./reducers/roleReducer";
import { downloadBarReducer } from './reducers/downloadBarReducer';
import collectionReducer from "./reducers/collectionReducer";
import secondaryOrderReducer from "./reducers/secondaryOrderReducer";
import presellerReducer from "./reducers/presellerLoadout";
import mdmDashboardReducer from './reducers/mdmDashboardReducer';
import { appTypeReducer } from './reducers/appTypeReducer';
import dayEndReducer from './reducers/dayEndReducer';

const rootReducer = combineReducers({
    sidebarState:sidebarOptionsReducer,
    configTypeState:configTypeReducer,
    serviceRegistry:ServiceRegistryReducer,
    mdmReducer : mdmReducer,
    bannerState: bannerReducer,
    popupState: genericPopupReducer,
    integrationRegistry:IntegrationDashboardReducer,
    fileFormat:FileFormatReducer,
    dateFilter:DateFilterReducer,
    otpPopupState:validateOtpPopupReducer,
    genericFilter: genericFilterReducer,
    locationData:LocationDataReducer,
    manageRoleState: manageRoleReducer,
    validateAPIState: valiadteAPIReducer,
    manageCoupons : manageCouponReducer,
    schemePlayground : schemePlaygroundReducer,
    portalConfigState: portalConfigReducer,
    eventConfigState: eventReducer,
    manageIncentive : manageIncentiveReducer,
    claims: claimsReducer,
    roleState: roleReducer,
    appTypeState: appTypeReducer,
    collections: collectionReducer,
    secondaryOrder: secondaryOrderReducer,
    presellerLoadoutState: presellerReducer,
    mdmDashboardReducer : mdmDashboardReducer,
    downloadBarReducer:downloadBarReducer,
    loyaltyManagement: loyaltyManagementReducer,
    dayEnd: dayEndReducer,
});

export default rootReducer;
